<template>

    <div>

        <h4 class="mb-3">Logs</h4>
        <vx-card id="logsDiv"  class="vs-con-loading__container">
            <div class="vx-row">
                <div class="vx-col md:w-1/4 w-4/12">
                    <p>Start time</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="startTime"></flat-pickr>
                </div>
                <div class="vx-col md:w-1/4 w-4/12">
                    <p>End time</p>
                    <flat-pickr class="w-full" :config="configDateTimePicker" v-model="endTime"></flat-pickr>
                </div>
                <div class="vx-col md:w-1/4 w-2/12">
                    <vs-button icon-pack="feather" icon="icon-arrow-right" color="success" class="mt-6 mr-1" @click="loadData"></vs-button>
                </div>

            </div>
            <vs-divider/>
            <p id="logContainer" style="white-space: pre-wrap; font-family: monospace; max-height: 550px; overflow: auto">{{logs}}</p>
        </vx-card>
    </div>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'

    export default {
        props: {
            workerId: {
                type: Number,
                required: true
            }
        },
        components: {
            flatPickr
        },
        data() {
            return {

                logs: '',
                startTime: null,
                endTime: null,

                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    time_24hr: true,
                    locale: {
                        firstDayOfWeek: 1
                    }
                }

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#logsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.put('/api/management/v1/worker/' + this.workerId + '/logs/', {
                    start_time: this.moment(this.startTime).format(),
                    end_time: this.moment(this.endTime).format()
                })
                loadPromise.then(function(response) {
                    thisIns.logs = response.data
                    const logContainer = thisIns.$el.querySelector('#logContainer')
                    logContainer.scrollTop = logContainer.scrollHeight
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#logsDiv > .con-vs-loading')
                })
            }
        },
        mounted() {
            const currentTime = new Date()
            this.startTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), 0, 0, 0)
            this.endTime = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), 23, 59, 59)
            this.loadData()
        }
    }

</script>
